export const THREE_DOTS = {
  THREE_DOTS_ANIMATION: 'three-dots-animation'
} as const;
